module.exports = __webpack_public_path__ + "static/scale-model-of-lords-park-zoo-in-elgin-illinois-1a9e2831259c9e8bd3a07602acde27fc.png";